import React, {useEffect, useRef, useState} from 'react';
import logo from "../logo.svg";
import {useDispatch, useSelector} from "react-redux";

import i18n from "../resources/i18nSetup";
import TicketNumber from "./ticketNumber";
import {Box, Container, Grid} from "@mui/material";
import PersonalDetails from "./personalDetails";
import {
  downloadTicketByUUid,
  getToken,
  setCSRFToken,
  updateClasses, updateIndexPage,
  updateStatus
} from "../redux/reducers/voucherPortalFormReducer";
import TicketDownload from "./ticketsForDownload";
import {RESPONSE_STATUS} from "../constants";
function VoucherPortalForm(props) {
  const {classes} = props;

  const dispatch = useDispatch();
  const indexPage = useSelector((state) =>
    state.VoucherPortalFormReducer.indexPage
  );



  useEffect(() => {
    let classes1 = classes
    if (process.env.REACT_APP_IS_STAND_ALONE === 'false' && !classes){
      classes1  = {
        h1_classes:"mb-10 text-3xl md:text-[43px] font-medium leading-snug break-words text-blue-800",
        h2_classes:"mb-4 text-2xl font-medium leading-snug break-words md:text-3xl text-blue-800",
        h3_classes:"mb-4 text-xl font-medium leading-snug text-blue-800 break-words md:text-2xl powermail_legend",
        p_classes:{regular:"text-element break-words leading-1.5 bg-none text-lg",error:"flex-1 leading-1.5 text-sm text-red-600 mt-[8px]"},
        label_classes:"powermail_label text-md text-blue-800 font-medium mb-2",
        input_classes:{regular:"powermail_input   w-full appearance-none flex-grow inline px-6 md:py-4 py-2 text-blue-800 placeholder-blue-800 duration-300 ease-out bg-white border-0 rounded-lg text-md focus:outline-none ring-1 ring-inset focus:ring-blue-800 hover:ring-blue-800 ring-grey-500 transition-border",
          datePicker:"powermail_date  powermail_field_error cursor-pointer flex-grow leading-1.5 w-full px-6 py-2 text-blue-800 placeholder-blue-800 duration-300 ease-out bg-white border-0 rounded-lg appearance-none cursor-pointer text-md focus:outline-none ring-1 ring-inset focus:ring-blue-800 hover:ring-blue-800 ring-grey-500 transition-border",
          submit:"powermail_submit leading-[1.6] cursor-pointer flex items-center px-6 py-4 w-auto text-white text-lg font-medium bg-blue-800 active:bg-blue-900 active:border-0 rounded-lg outline-none hover:shadow-md transition-all duration-300 ease-out focus-visible:ring-4 focus-visible:ring-blue-200"}
      }

    }
    dispatch(updateClasses(classes1))
  }, [classes]);

  const clickBackButton = () => {
    dispatch(updateIndexPage(0))
  }



  return (
      <main style={{ flexGrow: 1,
        overflow: 'auto'}}>

          <Grid container  >
            {indexPage == 0 &&   <TicketNumber></TicketNumber>}
            {indexPage == 1 &&   <PersonalDetails></PersonalDetails>}
            {indexPage == 2 &&   <TicketDownload></TicketDownload>}
            {indexPage > 0 &&  <Box mt={1}><input className={classes && classes.input_classes.submit} onClick={clickBackButton}
                   type={"button"} value={i18n.t("backButtonText")}/></Box>}
          </Grid>
      </main>
    )



}


export default VoucherPortalForm
